// primeReact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
// context
import { useContextSimulator } from "../../SimulatorContext";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { useEffect } from "react";
import { formatStyledCurrency } from "../../../../../../utils/formatStyledCurrency";

const FinancingInstallments = () => {
  const {
    setDate,
    setSelectedFinancingTerm,
    financingTerms,
    financingParcelValue,
    calculatePricePayment,
    calculateSACPayments,
    calculateInverseSACPayments,
    simulatorData,
    selectedPricingTable,
    financingValue,
    selectedFinancingTerm,
    setFinancingParcelsTableVisible,
    financingParcelsTableVisible,
    date,
    setFinancingParcelValue,
    setFinancingParcelsTable,
    setFinancingParcelCalc,
    setFinancingRate,
    calculateInterestFreePayments,
    translatePricingTablesTagToPortuguese,
    setFinancingInterest,
    calculateSACOCPayments
  } = useContextSimulator();

  useEffect(() => {
    const fetchFinancingValue = async () => {
      // console.log("financingValue: ", financingValue);
      // console.log("selectedFinancingTerm: ", selectedFinancingTerm);
      if (financingValue && selectedFinancingTerm && simulatorData) {
        const financingParcel = formatStyledCurrency(financingValue);
        // console.log("financingParcel: ", simulatorData.financing_rates);
        const currentTax = simulatorData.financing_rates
          .filter((rate) => selectedFinancingTerm <= rate.max_installments)
          .sort((a, b) => a.max_installments - b.max_installments)[0]?.percentage / 100;
        // const currentTax2 = simulatorData.financing_rates[simulatorData.financing_rates.length - 1].percentage / 100;
        // console.log("currentTax: ", currentTax);
        // console.log("currentTax2: ", currentTax2);
        setFinancingRate(currentTax);
        switch (selectedPricingTable) {
          case "price":
            await calculatePricePayment(
              financingParcel,
              currentTax,
              selectedFinancingTerm
            ).then((res) => {
              setFinancingParcelsTable(res.payments);
              setFinancingParcelValue(
                formatCurrency(res.payments[0].payment.toString())
              );
              setFinancingInterest(parseFloat(res.totalInterest));
              setFinancingParcelCalc(
                parseFloat(financingParcel) + res.totalInterest
              );
            });
            break;
          case "sac":
            await calculateSACPayments(
              financingParcel,
              currentTax,
              selectedFinancingTerm
            ).then((res) => {
              setFinancingParcelsTable(res.payments);
              setFinancingParcelValue(formatCurrency(res.bestTerm));
              setFinancingInterest(parseFloat(res.totalInterest));
              setFinancingParcelCalc(res.total);
            });
            break;
          case "sac_inverso":
            await calculateInverseSACPayments(
              financingParcel,
              currentTax,
              selectedFinancingTerm
            ).then((res) => {
              setFinancingParcelsTable(res.payments);
              setFinancingParcelValue(formatCurrency(res.bestTerm));
              setFinancingInterest(parseFloat(res.totalInterest));
              setFinancingParcelCalc(res.total);
            });
            break;
          case "sacre":
            //            console.log("Sacre");
            break;
          case "sacre_ib":
            //            console.log("Sacre IB");
            break;
          case "sacoc":
            //            console.log("SACOC");
            await calculateSACOCPayments(
              financingParcel,
              currentTax,
              selectedFinancingTerm
            ).then((res) => {
              setFinancingParcelsTable(res.payments);
              setFinancingParcelValue(formatCurrency(res.bestTerm));
              setFinancingInterest(parseFloat(res.totalInterest));
              setFinancingParcelCalc(res.total);
            });
            break;
          case "interest_free":
            await calculateInterestFreePayments(
              financingParcel,
              selectedFinancingTerm
            ).then((res) => {
              setFinancingParcelsTable(res.payments);
              setFinancingParcelValue(formatCurrency(res.payments[0].total.toString()));
              setFinancingParcelCalc(parseFloat(financingParcel));
            });
            break;
          default:
            break;
        }
      }
    };

    fetchFinancingValue();
  }, [financingValue, selectedFinancingTerm, selectedPricingTable]);

  return (
    <div className="row">
      <div className="row pt-2">
        {date && (
          <>
            <div className="col-xl-3 col-md-12">
              <label className="mb-3">Valor do Financiamento</label>
              <p className="input">{financingValue}</p>
            </div>
            <div className="col-xl-3 col-md-12 pb-2">
              <label className="mb-3">Parcelas do Financiamento</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: 18,
                  border: "1px solid #ced4da",
                  borderRadius: 8,
                  margin: 0,
                  justifyContent: "space-between",
                }}
              >
                <Dropdown
                  value={selectedFinancingTerm}
                  onChange={(e) => setSelectedFinancingTerm(e.value)}
                  options={financingTerms}
                  optionLabel="label"
                  placeholder="1 X"
                  className="border-0 bg-none px-1"
                  showClear
                  filter
                  filterBy="label"
                />
                {selectedPricingTable === "price" ? (
                  <span className="mx-auto">{financingParcelValue}</span>
                ) : (
                  <>
                    <span style={{ marginLeft: 10 }}>
                      {financingParcelValue}
                      <span className="mx-2">
                        <Tooltip target=".custom-target-icon" />
                        <i
                          className="custom-target-icon pi pi-info-circle p-text-secondary"
                          data-pr-tooltip={`A tabela de amortização escolhida é a 
                    ${translatePricingTablesTagToPortuguese(
                            selectedPricingTable
                          )}, 
                    clique no botão ao lado para consultar
                    todas as parcelas com suas respectivas taxas.`}
                          data-pr-position="top"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </span>
                    </span>
                    <Button
                      icon="fa fa-md fa-list"
                      // label="Ver Parcelas"
                      className="ml-4 py-2 float-end"
                      onClick={() =>
                        setFinancingParcelsTableVisible(
                          !financingParcelsTableVisible
                        )
                      }
                    />
                  </>
                )}
              </div>
            </div>
          </>
        )}
        <div className="col-xl-3 col-md-12 pb-2">
          <label className="mb-3">Data Pagamento</label>
          <Calendar
            value={date}
            onChange={(e) => {
              setDate(e.value);
              //              console.log(e.value);
            }}
            dateFormat={"dd/mm/yy"}
            mask="99/99/9999"
            className="w-100"
            locale="pt"
            minDate={new Date()}
          />
        </div>
      </div>
    </div>
  );
};

export default FinancingInstallments;
